var _g, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "80px",
    width: "80px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a00303"
    },
    d: "M310.468,8.17h-32.681L136.17,332.255v76.255l141.617,95.319h32.681 c35.949,0,65.362-29.413,65.362-65.362V73.532C375.83,37.583,346.417,8.17,310.468,8.17z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#de5735"
    },
    d: "M343.149,408.511v29.957c0,35.949-29.413,65.362-65.362,65.362h-76.255 c-35.949,0-65.362-29.413-65.362-65.362v-29.957H343.149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#de5735"
    },
    d: "M343.149,73.532v258.723H136.17V73.532c0-35.949,29.413-65.362,65.362-65.362h76.255 C313.736,8.17,343.149,37.583,343.149,73.532z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#de5735"
    },
    d: "M438.468,136.17h-32.681v239.66h32.681c35.949,0,65.362-29.413,65.362-65.362V201.532 C503.83,165.583,474.417,136.17,438.468,136.17z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d59281"
    },
    d: "M405.787,136.17H73.532c-35.949,0-65.362,29.413-65.362,65.362v108.936 c0,35.949,29.413,65.362,65.362,65.362h332.255c35.949,0,65.362-29.413,65.362-65.362V201.532 C471.149,165.583,441.736,136.17,405.787,136.17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a00303"
    },
    d: "M310.468,168.851h-32.681v174.298h32.681c17.974,0,32.681-14.706,32.681-32.681V201.532 C343.149,183.557,328.443,168.851,310.468,168.851z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#de5735"
    },
    d: "M310.468,201.532v108.936c0,17.974-14.706,32.681-32.681,32.681h-76.255 c-17.974,0-32.681-14.706-32.681-32.681V201.532c0-17.974,14.706-32.681,32.681-32.681h76.255 C295.762,168.851,310.468,183.557,310.468,201.532z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 212.426,
    cy: 212.426,
    r: 8.17
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 256,
    cy: 212.426,
    r: 8.17
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 299.574,
    cy: 212.426,
    r: 8.17
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 212.426,
    cy: 256,
    r: 8.17
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 256,
    cy: 256,
    r: 8.17
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 299.574,
    cy: 256,
    r: 8.17
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 212.426,
    cy: 299.574,
    r: 8.17
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 256,
    cy: 299.574,
    r: 8.17
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 299.574,
    cy: 299.574,
    r: 8.17
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M375.83,160.681c-4.513,0-8.17,3.658-8.17,8.17v174.298c0,4.512,3.657,8.17,8.17,8.17c4.513,0,8.17-3.658,8.17-8.17V168.851 C384,164.339,380.343,160.681,375.83,160.681z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.17,160.681c-4.513,0-8.17,3.658-8.17,8.17v174.298c0,4.512,3.657,8.17,8.17,8.17s8.17-3.658,8.17-8.17V168.851 C144.34,164.339,140.683,160.681,136.17,160.681z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M438.468,128H384V73.532C384,32.986,351.014,0,310.468,0H201.532C160.986,0,128,32.986,128,73.532V128H73.532 C32.986,128,0,160.986,0,201.532v108.936C0,351.014,32.986,384,73.532,384H367.66v54.468c0,31.536-25.657,57.191-57.191,57.191 H201.532c-31.535,0-57.191-25.656-57.191-57.191v-29.957c0-4.512-3.657-8.17-8.17-8.17s-8.17,3.658-8.17,8.17v29.957 C128,479.014,160.986,512,201.532,512h108.936C351.014,512,384,479.014,384,438.468V384h54.468C479.014,384,512,351.014,512,310.468 V201.532C512,160.986,479.014,128,438.468,128z M144.34,73.532c0-31.536,25.657-57.191,57.191-57.191h108.936 c31.535,0,57.191,25.656,57.191,57.191V128H144.34V73.532z M495.66,310.468c0,31.536-25.657,57.191-57.191,57.191H73.532 c-31.535,0-57.191-25.656-57.191-57.191V201.532c0-31.536,25.657-57.191,57.191-57.191h364.936 c31.535,0,57.191,25.656,57.191,57.191V310.468z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M310.468,160.681H201.532c-22.526,0-40.851,18.325-40.851,40.851v108.936c0,22.526,18.325,40.851,40.851,40.851h108.936 c22.526,0,40.851-18.325,40.851-40.851V201.532C351.319,179.006,332.994,160.681,310.468,160.681z M334.979,310.468 c0,13.516-10.996,24.511-24.511,24.511H201.532c-13.515,0-24.511-10.995-24.511-24.511V201.532 c0-13.516,10.996-24.511,24.511-24.511h108.936c13.515,0,24.511,10.995,24.511,24.511V310.468z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWound);
export default __webpack_public_path__ + "static/media/wound.09fd6be2f3cea58ed6102265247c3af7.svg";
export { ForwardRef as ReactComponent };